// removed by extract-text-webpack-plugin
module.exports = {"list":"list___1pUwa","empty":"empty___3BCse","listContent":"listContent___2iKoa","item":"item___1KNUJ","date":"date___1z2-K","unread":"unread___dWnwU","username":"username___3QlU7","viewall":"viewall___g8zSr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Notification/NotificationList.less
// module id = 700
// module chunks = 37